import { render, staticRenderFns } from "./download_xl.vue?vue&type=template&id=52f95562&scoped=true&"
import script from "./download_xl.vue?vue&type=script&lang=js&"
export * from "./download_xl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f95562",
  null
  
)

export default component.exports